import { apiFetch } from './apiClient';

/* Clientes › Contatos (sócio / representante) e o aviso diário de quem está sem contato */
export const listarContatos = () => apiFetch('/contatos');
export const avisoContatos = () => apiFetch('/contatos/aviso');
export const darCienciaContatos = () => apiFetch('/contatos/ciencia', { method: 'POST' });
export const criarContato = (clienteId, dados) => apiFetch(`/contatos/${clienteId}`, { method: 'POST', body: JSON.stringify(dados) });
export const atualizarContato = (id, dados) => apiFetch(`/contatos/item/${id}`, { method: 'PATCH', body: JSON.stringify(dados) });
export const excluirContato = (id) => apiFetch(`/contatos/item/${id}`, { method: 'DELETE' });
